import TextfieldOneTimePassword from '../../../molecules/TextfieldOneTimePassword';
import { SignInMethodOption, SignInVerification } from '../../../../entities/SignInMethod';
import CodeStepViewModel from './viewModel';
import {
  ActionButtons,
  Actions,
  CodeArea,
  ContinueButton,
  Destination,
  ErrorText,
  Header,
  Message,
  OtpField,
  ResendFeedbackText,
  ResendLink,
  ResendText,
  Subtitle,
  SwitchMethodButton
} from './styled';

type CodeStepProps = {
  verifyData: SignInVerification;
  method: SignInMethodOption;
  onVerified: (token: string) => void;
  onLoadingChange: (isLoading: boolean) => void;
  onContinueWithoutLogin: () => void;
  onMethodChanged: (method: SignInMethodOption) => void;
};

export default function CodeStep({
  verifyData,
  method,
  onVerified,
  onLoadingChange,
  onContinueWithoutLogin,
  onMethodChanged
}: CodeStepProps) {
  const {
    destination,
    hasError,
    errorMessage,
    isVerified,
    isResending,
    resendMessage,
    isResendError,
    switchMethodLabel,
    onCodeChange,
    handleResend,
    handleSwitchMethod,
    handleContinueWithoutCode
  } = CodeStepViewModel({
    verifyData,
    method,
    onVerified,
    onLoadingChange,
    onContinueWithoutLogin,
    onMethodChanged
  });

  return (
    <>
      <Header>
        <Message>Digite seu código de verificação</Message>
        <Subtitle>
          Nós enviamos seu código para <Destination>{destination}</Destination>
        </Subtitle>
      </Header>

      <CodeArea disabled={isVerified} aria-disabled={isVerified}>
        <OtpField hasError={hasError}>
          <TextfieldOneTimePassword onChange={onCodeChange} />
        </OtpField>

        {hasError && <ErrorText>{errorMessage}</ErrorText>}

        <Actions>
          <ResendText>
            Não recebeu?{' '}
            <ResendLink disabled={isResending} onClick={handleResend}>
              Reenviar o código
            </ResendLink>
          </ResendText>

          <ActionButtons className="action-buttons">
            <ContinueButton variant="inline" color="primary" onClick={handleContinueWithoutCode}>
              Continuar sem código
            </ContinueButton>

            {switchMethodLabel && (
              <SwitchMethodButton variant="inline" color="primary" disabled={isResending} onClick={handleSwitchMethod}>
                {switchMethodLabel}
              </SwitchMethodButton>
            )}
          </ActionButtons>
        </Actions>

        {resendMessage && <ResendFeedbackText isError={isResendError}>{resendMessage}</ResendFeedbackText>}
      </CodeArea>
    </>
  );
}
